import { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { ESTILO_BOTON_GENERAL_ACEPTAR, ESTILO_BOTON_GENERAL_CANCELAR, ESTILO_INPUT_GENERICO } from "../../../utils/const/estilos-const";
import "../../../style/style-cargando.css";
import { crearRiesgo, modificarRiesgo } from "../../../api/api-riesgo";
import cargandoCard from "../../../components/cargando-card";
import { useTranslation } from "react-i18next";
import ArrowBack from "../../../components/arrow-back";
import ProcessingDialog from "../../../components/processing-dialog";
import ToastComponent from "../../../components/toast-component";
import { obtenerListaPersona } from "../../../api/api-persona";
import Select from "react-select";

export default function RiesgoPage() {
  const { t } = useTranslation();
  const location = useLocation();
  const history = useHistory();
  const [cargandoPage, setCargandoPage] = useState(true);
  const [formData, setFormData] = useState(null);
  const [titulo, setTitulo] = useState("");

  const [processingVisible, setProcessingVisible] = useState(false);
  const [toastVisible, setToastVisible] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState("warning");

  const [listaPersonas, setListaPersonas] = useState([]);

  const [responsableAprobarRiesgo, setResponsableAprobarRiesgo] = useState(null);
  const [personaRecibeReporte, setPersonaRecibeReporte] = useState(null);

  const charLimits = {
    codigo: 64,
    descripcion: 4096,
    nota: 512,
    inicio: 4,
    fin: 4,
    color: 7,
  };

  useEffect(() => {
    // console.log("entro a Correos");
    iniciar();
  }, []);

  const iniciar = async () => {
    try {
      const data = location.state;
      // console.log("data");
      // console.log(data);
      if (data !== undefined && data !== null) {
        setFormData(data.params);
        setTitulo(data.titulo);
      }

      const listPersonas = await obtenerListaPersona(true);
      setListaPersonas(listPersonas);


      if (data.params.responsableAprobarRiesgo !== null) {
        const responsableSelected = JSON.parse(data.params.responsableAprobarRiesgo);
        setResponsableAprobarRiesgo(responsableSelected);
      }

      if (data.params.personaRecibeReporte !== null) {
        const personaRecibeReporteSelected = JSON.parse(data.params.personaRecibeReporte);
        setPersonaRecibeReporte(personaRecibeReporteSelected);
      }

      setCargandoPage(false);
    } catch (err) {
      console.log('iniciar err');
      console.log(err);
      setCargandoPage(false);
    }
  }

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    let finalValue = value;
    if (name === 'inicio') {
      finalValue = value.replace(/\D/g, '').slice(0, charLimits.inicio);
    } else if (name === 'fin') {
      finalValue = value.replace(/\D/g, '').slice(0, charLimits.fin);
    }
    setFormData({ ...formData, [name]: finalValue });
  };

  const handleColorChange = (e) => {
    let { value } = e.target;

    // Allow empty string
    if (value === '') {
      setFormData({
        ...formData,
        color: value,
      });
      return;
    }

    // If it doesn't start with #, add it automatically
    if (!value.startsWith('#')) {
      value = '#' + value;
    }

    // Allow "#" followed by 0-6 hex characters (allows partial input while typing)
    const hexPart = value.substring(1);
    if (/^[A-Fa-f0-9]{0,6}$/.test(hexPart) && value.length <= 7) {
      setFormData({
        ...formData,
        color: value.toUpperCase(),
      });
    }
  };

  const handleColorPickerChange = (e) => {
    const { value } = e.target;
    // Color picker always returns valid hex format
    setFormData({
      ...formData,
      color: value.toUpperCase(),
    });
  };

  const handleCancelClick = () => {
    history.goBack();
  };

  const validarFormulario = () => {
    let error = '';
    if (formData.descripcion === undefined || formData.descripcion === null || String(formData.descripcion).length === 0) {
      error = error + t('alert_debe_ingresar_descripcion') + '\n';
    }
    if (String(error).length > 0) {
      showToast(error, 'error');
      return false;
    }
    return true;
  }

  const handleSaveClick = async () => {
    // console.log('handleSaveClick');
    // lógica para guardar los cambios
    // console.log('formData');
    // console.log(formData);
    const valido = validarFormulario();
    if (valido === false) {
      return;
    }
    let objEnviar = {};
    objEnviar.id = formData.id;
    objEnviar.codigo = formData.codigo;
    objEnviar.inicio = formData.inicio;
    objEnviar.fin = formData.fin;
    objEnviar.descripcion = formData.descripcion;
    objEnviar.nota = formData.nota;
    objEnviar.responsableAprobarRiesgo = responsableAprobarRiesgo;
    objEnviar.personaRecibeReporte = personaRecibeReporte;
    objEnviar.color = formData.color;
    if (formData.id <= 0) {
      // console.log('crear correo');
      const creado = await crearRiesgo(objEnviar);
      // console.log('creado');
      // console.log(creado);
      if (creado === true) {
        alert(t('alert_se_creo_correctamente'));
        handleCancelClick();
      }
      if (creado === false) {
        alert(t('alert_no_se_pudo_crear'));
      }
    }
    if (formData.id !== 0) {
      // console.log('actualizar correo');
      const modificado = await modificarRiesgo(objEnviar);
      // console.log('modificado');
      // console.log(modificado);
      if (modificado === true) {
        alert(t('alert_se_modifico_correctamente'));
        handleCancelClick();
      }
      if (modificado === false) {
        alert(t('alert_no_se_pudo_modificar'));
      }
    }
  };

  const showToast = (message, type = "warning", durationMs = 3000) => {
    setToastMessage(message);
    setToastType(type);
    setToastVisible(true);
    // Auto-hide
    window.clearTimeout(showToast._timer);
    showToast._timer = window.setTimeout(() => {
      setToastVisible(false);
    }, durationMs);
  };

  const render = () => {
    // console.log('render correo');
    try {
      if (cargandoPage === true) {
        return cargandoCard();
      }
      if (cargandoPage === false && formData === null) {
        return (
          <div>
            <label> Sin data</label>
          </div>
        );
      }
      return (
        <div className="max-w-7xl mx-auto px-4 lg:px-6 bg-gray-100">
          <br />
          <div className="bg-white py-6 shadow-md rounded-lg sm:px-2">
            <div className="flex items-center justify-between mb-4">
              <div>
                <div className="flex items-center gap-2">
                  <ArrowBack onClick={handleCancelClick} />
                  <h2 className="text-xl font-bold text-gray-900">{titulo}</h2>
                </div>
              </div>
            </div>
            <br />
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label
                  htmlFor="codigo"
                  className="block text-md font-medium text-gray-700"
                >
                  {t("label_codigo")}
                </label>
                <input
                  id="codigo"
                  name="codigo"
                  type="text"
                  value={formData.codigo}
                  onChange={handleInputChange}
                  className={ESTILO_INPUT_GENERICO}
                  required
                  maxLength={charLimits.codigo}
                  placeholder={t("placeholder_ingresa_codigo")}
                />
                <p className="text-sm text-gray-500 flex justify-end">{formData.codigo?.length}/{charLimits.codigo}</p>
              </div>
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label
                  htmlFor="descripcion"
                  className="block text-md font-medium text-gray-700"
                >
                  {t("label_descripcion")}<span className="text-red-500">*</span>
                </label>
                <input
                  id="descripcion"
                  name="descripcion"
                  type="text"
                  value={formData.descripcion}
                  onChange={handleInputChange}
                  autoComplete="given-name"
                  className={ESTILO_INPUT_GENERICO}
                  required
                  maxLength={charLimits.descripcion}
                  placeholder={t("placeholder_ingresa_descripcion")}
                />
                <p className="text-sm text-gray-500 flex justify-end">{formData.descripcion.length}/{charLimits.descripcion}</p>
              </div>
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label
                  htmlFor="nota"
                  className="block text-md font-medium text-gray-700"
                >
                  {t("label_nota")}
                </label>
                <textarea
                  id="nota"
                  name="nota"
                  type="text"
                  value={formData.nota}
                  onChange={handleInputChange}
                  className={ESTILO_INPUT_GENERICO}
                  maxLength={charLimits.nota}
                  placeholder={t("placeholder_ingresa_nota")}
                  rows={5}
                />
                <p className="text-sm text-gray-500 flex justify-end">{formData.nota?.length}/{charLimits.nota}</p>
              </div>
            </div>
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12 md:col-span-12 lg:col-span-4 xl:col-span-4">
                <label
                  htmlFor="inicio"
                  className="block text-md font-medium text-gray-700"
                >
                  {t("label_inicio")}
                </label>
                <input
                  id="inicio"
                  name="inicio"
                  type="text"
                  inputMode="numeric"
                  value={formData.inicio}
                  onChange={handleInputChange}
                  autoComplete="given-name"
                  className={`${ESTILO_INPUT_GENERICO}`}
                  maxLength={charLimits.inicio}
                  placeholder={t("placeholder_ingresa_inicio")}
                />
                <p className="text-sm text-gray-500 flex justify-end">{formData.inicio.length}/{charLimits.inicio}</p>
              </div>
              <div className="col-span-12 md:col-span-12 lg:col-span-4 xl:col-span-4">
                <label
                  htmlFor="fin"
                  className="block text-md font-medium text-gray-700"
                >
                  {t("label_fin")}
                </label>
                <input
                  id="fin"
                  name="fin"
                  type="text"
                  inputMode="numeric"
                  value={formData.fin}
                  onChange={handleInputChange}
                  autoComplete="given-name"
                  className={`${ESTILO_INPUT_GENERICO}`}
                  maxLength={charLimits.fin}
                  placeholder={t("placeholder_ingresa_fin")}
                />
                <p className="text-sm text-gray-500 flex justify-end">{formData.fin.length}/{charLimits.fin}</p>
              </div>
            </div>
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label
                  htmlFor="color"
                  className="block text-md font-medium text-gray-700 mb-2"
                >
                  {t("label_color")}<span className="text-red-500">*</span>
                </label>
                <div className="flex gap-2 items-center">
                  <input
                    id="color"
                    name="color"
                    type="text"
                    value={formData.color || '#000000'}
                    onChange={handleColorChange}
                    className={ESTILO_INPUT_GENERICO}
                    placeholder="#FF00FF"
                    maxLength={7}
                  />
                  <input
                    type="color"
                    value={formData.color || '#000000'}
                    onChange={handleColorPickerChange}
                    className="h-10 w-16 cursor-pointer border border-gray-300 rounded"
                    title={t("label_seleccionar_color")}
                  />
                </div>
                <p className="text-sm text-gray-500 flex justify-end">{formData?.color?.length}/{charLimits.color}</p>
                {formData.color && !/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(formData.color) && (
                  <p className="text-sm text-red-500 mt-1">
                    {t("alert_formato_color_invalido")}
                  </p>
                )}
              </div>
            </div>
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12 md:col-span-12 lg:col-span-6 xl:col-span-6">
                <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="responsables">
                  {t("label_responsable_aprobar_riesgo")}
                </label>
                <Select
                  options={listaPersonas}
                  isSearchable={true}
                  isMulti={true}
                  isClearable={true}
                  value={responsableAprobarRiesgo}
                  onChange={(event) => setResponsableAprobarRiesgo(event)}
                  placeholder={t("placeholder_seleccione_responsable_aprobar_riesgo")}
                />
              </div>
              <div className="col-span-12 md:col-span-12 lg:col-span-6 xl:col-span-6">
                <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="personaRecibeReporte">
                  {t("label_persona_recibe_reporte")}
                </label>
                <Select
                  options={listaPersonas}
                  isSearchable={true}
                  isMulti={true}
                  isClearable={true}
                  value={personaRecibeReporte}
                  onChange={(event) => setPersonaRecibeReporte(event)}
                  placeholder={t("placeholder_seleccione_persona_recibe_reporte")}
                />
              </div>
            </div>
            <br />
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12 md:col-span-12 lg:col-span-12 xl:col-span-12">
                <div className="flex justify-between">
                  <button
                    type="button"
                    className={ESTILO_BOTON_GENERAL_CANCELAR}
                    onClick={handleCancelClick}
                  >
                    Cancelar
                  </button>
                  <button
                    type="button"
                    className={ESTILO_BOTON_GENERAL_ACEPTAR}
                    onClick={handleSaveClick}
                  >
                    Aceptar
                  </button>
                </div>
              </div>
            </div>
          </div>
          <ProcessingDialog visible={processingVisible} message={t("alert_procesando_solicitud")} />
          <ToastComponent
            visible={toastVisible}
            message={toastMessage}
            type={toastType}
            onClose={() => setToastVisible(false)}
          />
        </div>
      );
    } catch (err) {
      console.log('formData render err');
      console.log(err);
      return (
        <div>
          <label>{JSON.stringify(err)}</label>
        </div>
      );
    }
  }

  return render();
}
